<div class="upload-file-dialog">
    <sync-dialog
        [config]="{title: 'Upload files', isClosable: true, cancelButton: 'Cancel',onCancelClick: closeDialog}"
        [open]="showDialog" [isFullScreen]="false" [onClose]="closeDialog">
        <div class="upload-dialog-body">
            <app-upload-files [onUpload]="onUpload" [onDrop]="closeDialog" [isPublicUpload]="isPublicUpload"></app-upload-files>
        </div>
    </sync-dialog>
</div>